import { createRequest } from "@/common/helpers/RequestHelpers";
import apiURL from "./apiURL";
import { NotificationManager } from "react-notifications";
import { Actions as PAY_PERIOD_ACTIONS } from "@/redux/actions/payPeriodActions";
import { set } from "lodash";

const Types = {
	PAYSLIP_SEND_MODAL: "PAYSLIP_SEND_MODAL",
	PAYSLIP_SENDING: "PAYSLIP_SENDING",
	PAYSLIP_SENT: "PAYSLIP_SENT",
	PAYSLIP_UPDATING: "PAYSLIP_UPDATING",
	PAYSLIP_UPDATE: "PAYSLIP_UPDATE",
	PAYSLIP_DOWNLOADING: "PAYSLIP_DOWNLOADING",
	PAYSLIP_IN_PORTAL: "PAYSLIP_IN_PORTAL",
	PAYSLIP_IMPORT_SHOW_MODAL: "PAYSLIP_IMPORT_SHOW_MODAL",
	PAYSLIP_FILE_UPLOADING: "PAYSLIP_FILE_UPLOADING",
	PAYSLIP_FILE_UPLOADED: "PAYSLIP_FILE_UPLOADED",
	PAYSLIP_IMPORT_UPLOAD_TEMPLATE: "PAYSLIP_IMPORT_UPLOAD_TEMPLATE",
	PAYSLIP_IMPORT_FILE_UPLOADING: "PAYSLIP_IMPORT_FILE_UPLOADING",
	PAYSLIP_IMPORT_FILE_UPLOADED: "PAYSLIP_IMPORT_FILE_UPLOADED",
	PAYSLIP_IMPORT_DATA_PROCESSING: "PAYSLIP_IMPORT_DATA_PROCESSING",
	PAYSLIP_IMPORT_DATA_PROCESSED: "PAYSLIP_IMPORT_DATA_PROCESSED",
	PAYSLIP_SET_TAX_MODAL: "PAYSLIP_SET_TAX_MODAL",
	PAYSLIP_AGREEMENT_LOADING: "PAYSLIP_AGREEMENT_LOADING",
};
const LOCAL = false;
const request = createRequest({ urlPath: "/settings/", local: LOCAL });

const sendPayslipsModal = (status, id) => ({
	type: Types.PAYSLIP_SEND_MODAL,
	status,
	id,
});

const payslipsUpdating = (status) => ({
	type: Types.PAYSLIP_UPDATING,
	status,
});

const payslipsUpdated = (response) => ({
	type: Types.PAYSLIP_UPDATE,
	payload: response,
});

const getPayslipsRequest = async ({ payPeriodId, nextToken, ...params }) => {
	const { data } = await request({
		method: "GET",
		path: "payslips",
		query: { payPeriodId, nextToken, ...params },
	});

	const { list, offset } = data;

	console.log(offset);

	if (offset) {
		const more = await getPayslipsRequest({ payPeriodId, nextToken: offset, ...params });
		return [...list, ...more];
	} else {
		return list;
	}
};

const setAgreementPayslipsLoading = (status) => ({
	type: Types.PAYSLIP_AGREEMENT_LOADING,
	status,
});

const getPayslipsByAgreement = ({ agreementId }) => {
	return async (dispatch, getState) => {
		await dispatch(setAgreementPayslipsLoading(true));

		await request({
			method: "GET",
			path: `payslips/agreement`,
			query: { agreementId },
		})
			.then(async ({ data }) => {
				await dispatch(payslipsUpdated(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error getting payslips", "Get Payslips");
			}).finally(async () => {
				await dispatch(setAgreementPayslipsLoading(false));
			});
	};
};

const getPayslips = (params) => {
	return async (dispatch, getState) => {
		dispatch(payslipsUpdating(true));

		const payslips = await getPayslipsRequest({ ...params });

		dispatch(payslipsUpdated(payslips));

		dispatch(payslipsUpdating());
	};
};

const sendingPayslips = () => ({
	type: Types.PAYSLIP_SENDING,
});

const sentPayslips = (status, response) => ({
	type: Types.PAYSLIP_SENT,
	payload: response,
	status,
});

const sendPayslips = (params) => {
	const qs = new URLSearchParams(params).toString();

	return (dispatch, getState) => {
		const state = getState();

		const payPeriodId = state.payroll.currentPayPeriodId || state.payroll.payPeriodDetails.payPeriodId;
		dispatch(sendingPayslips());
		request({
			method: "GET",
			path: `sendPayslips/${payPeriodId}?${qs}`,
		})
			.then((data) => {
				console.log("entity data", data);
				dispatch(sentPayslips(true, data));
				dispatch(sendPayslipsModal(false));
				dispatch(PAY_PERIOD_ACTIONS.getPayPeriods())
				NotificationManager.success("Payslips sent successfully", "Send Period Payslips");
			}).catch(err => {
				console.error(err);
				dispatch(sentPayslips(false));
				NotificationManager.error("Error sending payslips", "Send Period Payslips");
			});
	};
};

const downloadPayslipStatus = (id, processing) => ({
	type: Types.PAYSLIP_DOWNLOADING,
	id,
	processing,
});

const downloadPayslip = (id) => {
	return (dispatch, getState) => {
		dispatch(downloadPayslipStatus(id, true));

		fetch(apiURL + `/settings/payslip/${id}/download`, {
			credentials: "include",
			method: "GET",
			// body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const popup = window.open(data.signedURL);
				if (!popup || popup.closed || typeof popup.closed == "undefined") {
					//Worked For IE and Firefox
					alert("Popup Blocker is enabled! Please add this site to your exception list.");
				}

				dispatch(downloadPayslipStatus(id, false));
			});
	};
};

const showImportModal = (status) => ({
	type: Types.PAYSLIP_IMPORT_SHOW_MODAL,
	status,
});

const setFileUploading = (file) => ({
	type: Types.PAYSLIP_FILE_UPLOADING,
	file,
});

const setFileUploaded = (payload) => ({
	type: Types.PAYSLIP_FILE_UPLOADED,
	payload,
});

const uploadFile = ({ file }) => {
	return (dispatch, getState) => {
		const state = getState();

		const path = "/settings/upload";

		// NotificationManager.success('Your File is being uploaded','Info')
		dispatch(setFileUploading(file.name));

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				name: file.name,
				type: file.type,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// step 1 upload to AWS
				fetch(data.url, {
					credentials: "include",
					method: "PUT",
					body: file,
					headers: {
						"Accept": "application/json",
						"Content-Type": file.type,
					},
				});
				dispatch(setFileUploaded(data.key));
			});
	};
};

const setPayslipImportDataProcessing = (key) => ({
	type: Types.PAYSLIP_IMPORT_DATA_PROCESSING,
	key,
});

const setPayslipImportDataProcessed = (processed, errors, warnings) => ({
	type: Types.PAYSLIP_IMPORT_DATA_PROCESSED,
	processed,
	errors,
	warnings,
});

const handlePayslipUpload = ({ key, org }) => {
	return (dispatch, getState) => {
		dispatch(setPayslipImportDataProcessing(key));

		const path = "/settings/upload/payslips";

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				key,
				org,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				dispatch(setPayslipImportDataProcessed(data.processed, data.errors, data.warnings));
			});
	};
};

const payslipImportTemplateDownloaded = (template) => ({
	type: Types.PAYSLIP_IMPORT_UPLOAD_TEMPLATE,
	template,
});

const getPayslipImportTemplate = () => {
	return (dispatch, getState) => {
		fetch(apiURL + "/settings/upload/payslips", {
			method: "GET",
			credentials: "include",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				dispatch(payslipImportTemplateDownloaded(data.template));
			})
			.catch((err) => console.error(err));
	};
};

const payslipInPortalUpdated = (response) => ({
	type: Types.PAYSLIP_IN_PORTAL,
	response,
});

const showInPortal = (body) => {
	return (dispatch, getState) => {
		// dispatch(downloadPayslip(body && body.index,true))
		fetch(apiURL + `/settings/payslip/show`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(payslipInPortalUpdated(body));
			})
			.catch((err) => console.error(err));
	};
};

const setTaxModal = ({ show, tax }) => ({
	type: Types.PAYSLIP_SET_TAX_MODAL,
	show,
	tax,
});

const Actions = {
	getPayslips,
	getPayslipsByAgreement,
	downloadPayslip,
	sendPayslips,
	showImportModal,
	sendPayslipsModal,
	getPayslipImportTemplate,
	uploadFile,
	handlePayslipUpload,
	showInPortal,
	setTaxModal,
};

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions
